import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white shadow-md'
          : 'bg-white/10 backdrop-blur-md'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img 
            src="https://static.readdy.ai/image/2b7b3ddf793f3c719c327adf3690ce51/63eb944a0221ff0e07f66c21e4e2f04f.png" 
            alt="Logo" 
            className="h-12 w-auto"
          />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <a
            href="#modulos"
            className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              isScrolled ? 'text-gray-700 hover:text-[#1A3A2E]' : 'text-white hover:text-[#39FF14]'
            }`}
          >
            Módulos
          </a>
          <a
            href="#metodologia"
            className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              isScrolled ? 'text-gray-700 hover:text-[#1A3A2E]' : 'text-white hover:text-[#39FF14]'
            }`}
          >
            Metodología
          </a>
        </div>

        <div className="flex items-center gap-4">
          <button
            className={`hidden md:block px-6 py-2.5 text-sm font-medium border-2 rounded-lg transition-all whitespace-nowrap cursor-pointer ${
              isScrolled
                ? 'border-[#1A3A2E] text-[#1A3A2E] hover:bg-[#1A3A2E] hover:text-white'
                : 'border-white text-white hover:bg-white hover:text-[#1A3A2E]'
            }`}
          >
            Acceso Alumnos
          </button>
          <button className="px-6 py-2.5 bg-[#39FF14] text-black text-sm font-bold rounded-lg hover:bg-[#32E010] transition-all whitespace-nowrap cursor-pointer">
            Inscribirse Ahora
          </button>
        </div>
      </div>
    </nav>
  );
}
